import { BUGREPORTER_URL } from "../../constants/app";
import { useScrollDirection } from "../../hooks/useScrollDirection";

/** バナー分の下部余白。BugReporterBannerを表示する全ページで使用 */
export const BANNER_BOTTOM_PADDING = "pb-16";

export function BugReporterBanner() {
  const scrollDirection = useScrollDirection();
  const isHidden = scrollDirection === "down";

  return (
    <aside
      aria-label="バグ報告バナー"
      // React 18 は inert を boolean 属性として認識しないため文字列で渡す。
      // React 19 で正式サポート後は inert={isHidden || undefined} に変更可能。
      inert={isHidden ? "" : undefined}
      className={`fixed bottom-0 left-0 right-0 z-30 p-3 pointer-events-none motion-reduce:transition-none transition-[transform,opacity] duration-300 ease-in-out ${
        isHidden ? "translate-y-full opacity-0" : "translate-y-0 opacity-100"
      }`}
    >
      <a
        href={BUGREPORTER_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="BugReporter — 品質向上にご協力ください（新しいタブで開きます）"
        className="pointer-events-auto mx-auto flex max-w-5xl items-center gap-3 rounded-full border border-gray-200 bg-white px-5 py-2.5 shadow-sm transition-shadow hover:shadow-md"
      >
        <img
          src="/img/bugreporter-logo.webp"
          alt="BugReporter"
          className="h-6 w-auto shrink-0"
          loading="lazy"
        />
        <span className="text-gray-600 text-sm">
          品質向上にご協力ください。バグレポーターのチャットAIがサポートします
        </span>
      </a>
    </aside>
  );
}
